import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest'
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'vehicles',
    pluginName: 'VEHICLE',
    entityName: 'VEHICLE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch Vehicle action creators
export const fetchVehicleInit = () => { return crudActions.fetchInit(); }
export const fetchVehicleStart = () => { return crudActions.fetchStart(); }
export const fetchVehicleSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchVehicleFail = () => { return crudActions.fetchFail(); }
export const fetchVehicles = filter => {
    return async dispatch => {
        await crudActions.fetch(dispatch, filter);
    }

}// Create Vehicle  action creators
export const createVehicleInit = () => { return crudActions.createInit(); };
export const createVehicleStart = () => { return crudActions.createStart(); };
export const createVehicleSuccess = createdVehicle => { return crudActions.createSuccess(createdVehicle); };
export const createVehicleFail = error => { return crudActions.createFail(error); };
export const createVehicle = vehicle => {
    return async dispatch => {
        await crudActions.create(dispatch, vehicle);
    };
};

// Delete Vehicle  action creators

export const bulkDeleteVehicleInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeleteVehicleStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeleteVehicleSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeleteVehicleFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeleteVehicle = vehicleIDs => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, vehicleIDs);
    };
};

// Delete Vehicle  action creators
export const deleteVehicleInit = () => { return crudActions.deleteInit(); };
export const deleteVehicleStart = () => { return crudActions.deleteStart(); };
export const deleteVehicleSuccess = deletedVehicle => { return crudActions.deleteSuccess(deletedVehicle); };
export const deleteVehicleFail = error => { return crudActions.deleteFail(error); };
export const deleteVehicle = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};


// Edit vehicle  action creators
export const editVehicleInit = () => { return crudActions.editInit(); };
export const editVehicleStart = () => { return crudActions.editStart(); };
export const editVehicleSuccess = editedVehicle => { return crudActions.editSuccess(editedVehicle); };
export const editVehicleFail = error => { return crudActions.editFail(error); };
export const editVehicle = vehicle => {
    return async dispatch => {
        await crudActions.edit(dispatch, vehicle);
    };
};

// Load vehicle action creators
export const loadVehicleInit = () => { return crudActions.loadInit(); };
export const loadVehicleStart = () => { return crudActions.loadStart(); };
export const loadVehicleSuccess = loadedVehicle => { return crudActions.loadSuccess(loadedVehicle); };
export const loadVehicleFail = error => { return crudActions.loadFail(error); };
export const loadVehicle = id => {
    return async dispatch => {

        await crudActions.load(dispatch, id);
    };
};

export const fetchCustomers = () => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/list', { listAll: true });
            if (res.data && res.data.succeeded) {
                let customers = [];

                for (var cs of res.data.result.data) {
                    customers.push({ value: cs.CustomerID, displayValue: `${cs.Name}` });
                }
                return customers;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list delivery notes  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}
